import styled from "styled-components";

export const VerticallySpaced = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--${({ $spacing }) => ($spacing ? $spacing : `large-spacing`)});
`;

export default VerticallySpaced;
